import { inject } from '@angular/core';
import { Routes } from '@angular/router';

import { EmptyWithOutletPageComponent } from '~/core/pages';
import { InitializationPageComponent } from '~/initialization/initialization.page.component';
import { SessionService } from '~/session/session.service';

export const rootRoutes: Routes = [
	{
		path: '',
		component: InitializationPageComponent,
		children: [
			{
				path: '',
				component: EmptyWithOutletPageComponent,
				children: [
					{
						// LOGIN
						path: '',
						canMatch: [
							async () => {
								const sessionService = inject(SessionService);
								const role = await sessionService.getAdminRole();
								return role === null;
							},
						],
						component: EmptyWithOutletPageComponent,
						children: [
							{
								path: '**',
								loadComponent: async () => {
									const m = await import('~/auth/auth.page.component');
									return m.AuthPageComponent;
								},
							},
						],
					},
					{
						// NO ACCESS
						path: '',
						canMatch: [
							async () => {
								const sessionService = inject(SessionService);
								const canAccess = await sessionService.canAccessPage();
								return !canAccess;
							},
						],
						loadComponent: async () => {
							const m = await import('~/no-access/no-access.page.component');
							return m.NoAccessPageComponent;
						},
					},
					{
						// HOME
						path: '',
						canMatch: [
							() => {
								const sessionService = inject(SessionService);
								const session = sessionService.currentSession;
								const canAccessHome = !!session;
								return canAccessHome;
							},
						],
						children: [
							{
								path: '',
								loadChildren: async () => {
									const m = await import('~/home/home.router.module');
									return m.HomeRouterModule;
								},
							},
							{
								// Fail-safe
								path: '**',
								redirectTo: '',
							},
						],
					},
				],
			},
		],
	},
];
